// extracted by mini-css-extract-plugin
module.exports = {"volume_container":"volume-slider_volume_container__2V4w9","volume_icon":"volume-slider_volume_icon__UX_bo","volume_slider":"volume-slider_volume_slider__PCDA0"};